import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { ICmsMonthlyPassOfferResponse } from "../../Orchestrator/Types/Interface/ICMSOffers";

export const getCmsMonthlyPassOffers = async () => {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsMonthlyPassOffersAPI;

  const params = new URLSearchParams();
  const locale = await getLocaleFromCookie();

  params.append("locale", locale);
  params.append("populate", "origin");
  params.append("populate", "destination");
  params.append("populate", "image");

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsMonthlyPassOfferResponse>(
    endpointWithParams,
    "GET"
  );
}
